<template>   
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true" >  
        <div class="modal-dialog" style="max-width:1700px;">  
            <div class="modal-content"  style="min-height: 550px;">  
                <div class="modal-header"> 
					<h2>{{titulo}}</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" >
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg"/>
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y m-5">
                    <div class="row g-6 g-xl-12">  
                        <div class="col-12 col-sm-12" v-if="matricula"> 
                            <div class="form-group"> 
                                <label for="dia" class="form-check-label">dataPublicacao:</label>   
                                <input required type="date" name="dataPublicacao" class="form-control" v-model="dataPublicacao">  
                            </div>
                        </div>  
                        <div class="col-12 col-sm-12" v-if="matricula"> 
                            <div class="form-group"> 
                                <label for="descricao" class="form-check-label">Documento da Publicação:</label>   
                            <input required type="text"  name="" class="form-control" v-model="docPublicacao">  
                            </div>
                        </div>  
                        <div class="col-12"> 
                            <div class="form-group"> 
                                <label for="observacao" class="form-check-label">Observação:</label>   
                                <textarea required type="text" rows="5"  name="" class="form-control" v-model="observacao"/>  
                            </div>
                        </div>  
                    </div>  
				</div>  
                <div class="modal-footer"  > 
                    <BotaoSalvar @click="salvar" :processando="processando"></BotaoSalvar>   
				</div> 
			</div> 
		</div> 
	</div>  
</template>
 
<script lang="ts">
     
	import CadastroInline from '@/components/aplicacao/CadastroInline.vue';    
    import Multiselect from '@vueform/multiselect'
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue'; 
    import { Options , Vue  } from "vue-class-component";   
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import   SiteUtils   from '@/assets/ts/aplicacao/site';  
	import $ from "jquery"   
    import {  Prop   } from 'vue-property-decorator';   
    import MatriculaHistoricoService from   "@/service/v1/sigap/MatriculaHistoricoService"   
         
	  
    @Options({
        name: "InformacaoMatricula",
        components: {  CadastroInline  , Multiselect, ListaCampoForm, BotaoSalvar   },  
        emits: [  'historico-matricula-criada'],  
    }) 
    export default class InformacaoMatricula extends Vue {
          
        @Prop( ) readonly modal!: any  
        @Prop( ) readonly perfis!: any  
        @Prop( ) readonly matricula!: any

        public service = new MatriculaHistoricoService();  
 
        public dataPublicacao: any = null ; 
        public docPublicacao: any = null ;  
        public observacao: any  =  null ;  
        public titulo = 'Inserir Informação da Matrícula' ;
        public processando = false;   
           
        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin,  PerfilConfig.ChefeSTE,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }
   
        public getdados(){   
            let dados:any = {};  
            dados.dataPublicacao = this.dataPublicacao;  
            dados.docPublicacao = this.docPublicacao;  
            dados.matriculaId = this.matricula.id;  
            dados.observacao = this.observacao;   
            return dados;
        }
 
        public sucesso(){  
            this.$emit("historico-matricula-criada", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }
    
        public salvar(){
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.service.cadastrar( dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Cadastrado com sucesso! ' ,  response.message  ); 
                    this.sucesso();  
                    this.processando = false ;  
                }) 
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });  
            }, 100); 
        }   

    } 
</script> 